export namespace JWT {
    function decodeBase64ToUtf8Json(base64: string): any {
        const binary = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
        const json = new TextDecoder('utf-8').decode(binary);
        return JSON.parse(json);
    }

    export function read<T>(key: string): T | undefined {
        const token = localStorage.getItem('token');
        if (!token) return;

        const payload = token.split('.')[1];
        const buf = decodeBase64ToUtf8Json(payload);

        return buf[key];
    }

    export function all(): any {
        const token = localStorage.getItem('token');
        if (!token) return;

        const payload = token.split('.')[1];
        return decodeBase64ToUtf8Json(payload);
    }
}